import { Grid as ChakraGrid } from '@chakra-ui/layout';

export const Grid = ChakraGrid;
